/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ShareConfig } from './shareConfig';
import type { ShareCreateRequestSchemaExpirationDays } from './shareCreateRequestSchemaExpirationDays';

export interface ShareCreateRequestSchema {
  search_id: string;
  expiration_days: ShareCreateRequestSchemaExpirationDays;
  config?: ShareConfig | null;
}
